import { RequireAuth } from '@/features/login/RequireAuth.tsx';
import { CheckSignUpStatusForOnboarding } from '@/features/OnBoarding/CheckSignUpStatusForOnboarding.tsx';
import {
  STEP_ACCOUNT_URL,
  STEP_BRANDING_URL,
  STEP_PASSWORD_URL,
  STEP_PAYMENT_URL,
  STEP_REVIEW_URL,
} from '@/features/OnBoarding/constants.ts';
import { InvalidToken } from '@/features/OnBoarding/InvalidToken.tsx';
import { LastStep } from '@/features/OnBoarding/LastStep.tsx';
import { OnBoardingLayout } from '@/features/OnBoarding/OnBoardingLayout.tsx';
import { OnBoardingStepper } from '@/features/OnBoarding/OnBoardingStepper.tsx';
import { StepAccount } from '@/features/OnBoarding/StepAccount/StepAccount.tsx';
import { StepBranding } from '@/features/OnBoarding/StepBranding.tsx';
import { StepPassword } from '@/features/OnBoarding/StepPassword.tsx';
import { StepPayment } from '@/features/OnBoarding/StepPayment/StepPayment.tsx';
import { StepReview } from '@/features/OnBoarding/StepReview/StepReview.tsx';
import { RouteObject } from 'react-router';

export const OnBoardingRouter: RouteObject[] = [
  {
    path: `/onboarding`,
    Component: OnBoardingLayout,
    children: [
      {
        path: `/onboarding/invalid`,
        Component: InvalidToken,
      },
      {
        path: `/onboarding/step/`,
        Component: () => (
          <RequireAuth
            redirect={'/onboarding/invalid'}
            graceful={true}
          >
            <OnBoardingStepper />
          </RequireAuth>
        ),
        children: [
          {
            path: STEP_PASSWORD_URL,
            Component: () => (
              <CheckSignUpStatusForOnboarding>
                <StepPassword />
              </CheckSignUpStatusForOnboarding>
            ),
          },
          {
            path: STEP_ACCOUNT_URL,
            Component: () => (
              <CheckSignUpStatusForOnboarding>
                <StepAccount />
              </CheckSignUpStatusForOnboarding>
            ),
          },
          {
            path: STEP_BRANDING_URL,
            Component: () => (
              <CheckSignUpStatusForOnboarding>
                <StepBranding />
              </CheckSignUpStatusForOnboarding>
            ),
          },
          {
            path: STEP_PAYMENT_URL,
            Component: () => (
              <CheckSignUpStatusForOnboarding>
                <StepPayment />
              </CheckSignUpStatusForOnboarding>
            ),
          },
          {
            path: STEP_REVIEW_URL,
            Component: () => (
              <CheckSignUpStatusForOnboarding>
                <StepReview />
              </CheckSignUpStatusForOnboarding>
            ),
          },
          {
            path: `/onboarding/step/last/success`,
            Component: () => <LastStep />,
          },
        ],
      },
    ],
  },
];
